import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DirectivesModule } from 'src/app/directives/directives.module';

import { MaterialModule } from '../../../../material-module';
import { AmountItemRendererComponent } from './amount-item-renderer/amount-item-renderer.component';
import { BoolItemRendererComponent } from './bool-item-renderer/bool-item-renderer.component';
import { CopyItemRendererComponent } from './copy-item-renderer/copy-item-renderer.component';
import { DateTimeItemRendererComponent } from './date-time-item-renderer/date-time-item-renderer.component';
import { IconButtonItemRendererComponent } from './icon-button-item-renderer/icon-button-item-renderer.component';
import { MenuItemRendererComponent } from './menu-item-renderer/menu-item-renderer.component';
import { NumberItemRendererComponent } from './number-item-renderer/number-item-renderer.component';
import { PercentItemRendererComponent } from './percent-item-renderer/percent-item-renderer.component';
import { AmountRendererPipe } from './pipes/amount-renderer.pipe';
import { DateRendererPipe } from './pipes/date-renderer.pipe';
import { NumberRendererPipe } from './pipes/number-renderer.pipe';
import { PercentRendererPipe } from './pipes/percent-renderer.pipe';
import { TextItemRendererComponent } from './text-item-renderer/text-item-renderer.component';
import { WarningItemRendererComponent } from './warning-item-renderer/warning-item-renderer.component';

export { AmountItemRendererComponent } from './amount-item-renderer/amount-item-renderer.component';
export { BoolItemRendererComponent } from './bool-item-renderer/bool-item-renderer.component';
export { CopyItemRendererComponent } from './copy-item-renderer/copy-item-renderer.component';
export { DateTimeItemRendererComponent } from './date-time-item-renderer/date-time-item-renderer.component';
export { MenuItemRendererComponent } from './menu-item-renderer/menu-item-renderer.component';
export { NumberItemRendererComponent } from './number-item-renderer/number-item-renderer.component';
export { PercentItemRendererComponent } from './percent-item-renderer/percent-item-renderer.component';
export { TextItemRendererComponent } from './text-item-renderer/text-item-renderer.component';

@NgModule({
  declarations: [
    AmountItemRendererComponent,
    AmountRendererPipe,
    BoolItemRendererComponent,
    CopyItemRendererComponent,
    DateRendererPipe,
    DateTimeItemRendererComponent,
    IconButtonItemRendererComponent,
    MenuItemRendererComponent,
    NumberItemRendererComponent,
    NumberRendererPipe,
    PercentItemRendererComponent,
    PercentRendererPipe,
    TextItemRendererComponent,
    WarningItemRendererComponent,
  ],
  exports: [
    AmountItemRendererComponent,
    AmountRendererPipe,
    CopyItemRendererComponent,
    DateTimeItemRendererComponent,
    MenuItemRendererComponent,
    NumberItemRendererComponent,
    NumberRendererPipe,
    PercentItemRendererComponent,
    PercentRendererPipe,
    TextItemRendererComponent,
  ],
  imports: [CommonModule, MaterialModule, DirectivesModule],
})
export class ItemRenderersModule {}
